import { createFileRoute } from "@tanstack/react-router";

import { AboutPage } from "@/components/marketing/about-page";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/(public)/about")({
  head: () => pageHead("about"),
  component: AboutPage,
});
